export const formatNumber = (number, fixed = 2, separator = ",") =>
  number.toFixed(fixed).replace(/\d(?=(\d{3})+\.)/g, `$&${separator}`);

export const formatInteger = (number, separator = ",") =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `${separator}`);

export const formatCurrency = (number, prefix = "$", ...rest) => {
  const currency = formatNumber.call(null, Math.abs(number), ...rest);
  const prefixedCurrency = `${number >= 0 ? "" : "-"}${prefix}${currency}`;

  return prefixedCurrency;
};
